import { useState } from 'react';
import { Tag, Link, Text } from '@nimbus-ds/components';
import { Stack } from 'commons/components';
import useTranslationFulfillmentOrders from 'domains/FulfillmentOrders/useTranslationFulfillmentOrders';

interface FulfillmentOrderSelectedHeaderProps {
  labels: string[];
  isLoading: boolean;
}

function FulfillmentOrderSelectedHeader({
  labels,
  isLoading,
}: Readonly<FulfillmentOrderSelectedHeaderProps>) {
  const t = useTranslationFulfillmentOrders('printManager.informationCard');
  const [showAllLabels, setShowAllLabels] = useState(false);
  const firstTenLabels = labels.slice(0, 10);
  const restOfLabels = labels.slice(10);
  return (
    <Stack column align="stretch" spacing="tight">
      <Text fontSize="caption">{t('selectedOrders')}</Text>
      <Stack wrap spacing="tight">
        {!isLoading &&
          firstTenLabels
            .sort((a, b) => a.localeCompare(b))
            .map((label) => (
              <Tag key={label} id={label} appearance="success">
                <Text color="success-textLow">{label}</Text>
              </Tag>
            ))}
        {showAllLabels &&
          restOfLabels
            .sort((a, b) => a.localeCompare(b))
            .map((label) => (
              <Tag key={label} id={label} appearance="success">
                <Text color="success-textLow">{label}</Text>
              </Tag>
            ))}
        {!isLoading && restOfLabels.length > 0 && (
          <Link onClick={() => setShowAllLabels(!showAllLabels)}>
            {showAllLabels
              ? t('showMoreLabels.less')
              : `${t('showMoreLabels.more')} (${restOfLabels.length})`}
          </Link>
        )}
        {isLoading && (
          <>
            <Tag.Skeleton />
            <Tag.Skeleton />
          </>
        )}
      </Stack>
    </Stack>
  );
}

export default FulfillmentOrderSelectedHeader;
